module.exports = __webpack_public_path__ + "img/75590.1c50a144.svg";